//logic for gallery component
const galleryComponent = document.querySelector('.gallery-component');
if (galleryComponent) {
    let scEditorMode = document.querySelector('.sc-editor-mode');
    if (!scEditorMode) {
        //counting images for select mobile gallery
        // select all options
        // select all select-content group, and loop through each group
        // find each groups' children count and append to each option by order
        const GAL_SEL = document.querySelector('.gallery-select');
        const options = [...GAL_SEL.querySelectorAll('option')];
        const selectContentGroups = [...GAL_SEL.querySelectorAll('.select-content')];
        // I don't think this ever gets called
        selectContentGroups.forEach((group, idx) => {
            const imgCount = group.querySelectorAll('.gallery-item').length;
            const optionText = options[idx].textContent;
            options[idx].innerHTML = `${optionText} (${imgCount})`;
        });
    }
    const SIMPLE_LINK = document.querySelectorAll('.simple-link');
    if (SIMPLE_LINK) {
        window.addEventListener('load', () => {
            Array.from(document.getElementsByClassName('simple-link'), (btn) => {
                const count = document.querySelectorAll(
                    `div.tab-item-content[data-id="${btn.dataset.id}"] .gallery-item`
                ).length;
                btn.appendChild(document.createTextNode(` (${count})`));
            });
        });
    }
    const GALLERY_HEADER = document.querySelectorAll('.gallery-header');
    if (GALLERY_HEADER) {
        if (!scEditorMode) {
            //on page load make first btn of gallery header selected
            GALLERY_HEADER.forEach((galHeader) => {
                const GALLERY_TAB_HEADER_LINKS = galHeader.firstElementChild;
                const GALLER_TAB_HEADER_FIRST_LINK = GALLERY_TAB_HEADER_LINKS.firstElementChild;
                //on page load first btn of gallery header is selected
                window.addEventListener('load', () => {
                    setSelectedGallerySection(galHeader, GALLER_TAB_HEADER_FIRST_LINK);
                });
            });
            //on page load first btn of gallery content link is active and the content is visible
            const GALLERY_LINKS_WRAPPER = document.querySelectorAll('.gallery-links-wrapper');
            GALLERY_LINKS_WRAPPER.forEach((wrap) => {
                const FIRST_LINK_CONTENT = wrap.firstElementChild;
                window.addEventListener('load', () => {
                setActiveGalleryTab(wrap, FIRST_LINK_CONTENT);
                });
            });
        }
        //handle tab functionality for gallery header buttons
        let handleGalleryLinkClick = (e) => {
            let galleryHeader = e.target.parentElement.parentElement;
            setSelectedGallerySection(galleryHeader, e.target);
        };
        Array.from(document.getElementsByClassName('gallery-tab-link'), (btn) =>
            btn.addEventListener('click', handleGalleryLinkClick, false)
        );

        let handleClick = (e) => {
            let wrap = e.target.parentElement;
            setActiveGalleryTab(wrap, e.target);
        };
        // get the gallery tabs
        let tablinks = galleryComponent.querySelectorAll('.tablinks');
        Array.from(tablinks, (btn) =>
        {
            btn.addEventListener('click', handleClick, false);
        });
    }

    // set selected Gallery
    function setSelectedGallerySection(galleryComponentHeader, selectedGalleryLink) {
      // remove `selected` class from all Gallery buttons
      Array.from(galleryComponentHeader.querySelectorAll('.selected'), (e) =>
          e.classList.remove('selected')
      );
      selectedGalleryLink.classList.add('selected');
      galleryComponentHeader
          .querySelector(`div.gallery-tab-header-content[data-tab*="${selectedGalleryLink.dataset.tab}"]`)
          .classList.add('selected');
    }

    // set active gallery tab
    function setActiveGalleryTab(galleryTabComponent, activeTab) {
      // get all the tablinks
      Array.from(galleryTabComponent.querySelectorAll('.active'), (e) =>
          e.classList.remove('active')
      );
      activeTab.classList.add('active');
      // get the Gallery wrapper
      let galleryWrapper = galleryTabComponent.parentElement.querySelector('.tab-content-wrapper');
      Array.from(galleryWrapper.querySelectorAll('.active'), (e) =>
          e.classList.remove('active')
      );
      let activeTabContent = galleryWrapper.querySelector(`div.tab-item-content[data-id*="${activeTab.dataset.id}"]`);
      activeTabContent.classList.add('active');
      let galleryItems = activeTabContent.querySelectorAll('.gallery-item:not(.lg-initialised)');
      if (galleryItems && galleryItems.length > 0) {
          initializeLightGallery(galleryItems);
      }
    }

    //logic for gallery dropdown on mobile view
    const GALLERY_SELECT = document.querySelectorAll('.gallery-select-component');
    if (GALLERY_SELECT) {
        window.addEventListener('load', () => {
            const SELECT_CONTENT_LIST = document.querySelectorAll('.select-content-list');
            SELECT_CONTENT_LIST.forEach((selectContentList) => {
                const SELECT_CONTENT_LIST_FIRST = selectContentList.firstElementChild;
                SELECT_CONTENT_LIST_FIRST.classList.add('visible');
            });
            // what's this for?
            const GALLERY_SELECT_WRAP = document.querySelectorAll('.gallery-select');
        });
        GALLERY_SELECT.forEach((galSelComp) => {
            let valueNew = () => {
                const SELECT_CONTENT = galSelComp.querySelectorAll('.select-content');
                const GALLERY_SELECT = galSelComp.querySelector('.gallery-select');
                SELECT_CONTENT.forEach((selectContent) => {
                    selectContent.classList.remove('visible');
                });
                SELECT_CONTENT[GALLERY_SELECT.selectedIndex].classList.add('visible');
            };

            Array.from(document.getElementsByClassName('gallery-select'), (select) =>
                select.addEventListener('change', valueNew, false)
            );
        });
    }
    //init lightbox plugin
    const MEDIA_CONTENT = document.querySelectorAll('.gallery-layout');
    if (MEDIA_CONTENT) {
        //center gallery link if it's only one element
        const GALLERY_LINK_WRAPPER = document.querySelectorAll('.gallery-links-wrapper');
        GALLERY_LINK_WRAPPER.forEach((wrapper) => {
            const GALLERY_LINK_WRAPPER_CHILDREN = wrapper.childElementCount;
            if (GALLERY_LINK_WRAPPER_CHILDREN < 10) {
                wrapper.style.justifyContent = 'center';
            }
        });
        if (isMobileDevice()) {
            MEDIA_CONTENT.forEach((media) => {
                const initLightboxEl = media.querySelector('.grid');
                let galleryItems = initLightboxEl.querySelectorAll('.gallery-item');
                if (galleryItems && galleryItems.length > 0) {
                    initializeLightGallery(galleryItems);
                }
            });
        }
    }
}

//initialize lightGallery for each gallery-layout
function initializeLightGallery(galleryItems) {
      let galleryItemsArray = [];
      galleryItems.forEach((galleryElement) => {
          let imgSrc = galleryElement.dataset.src ? galleryElement.dataset.src : galleryElement.querySelector('img').src;
          let galleryObj = {
              "src": imgSrc,
              "thumb": imgSrc,
              "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : ""
          };
          if (galleryElement.dataset.iframe) {
              galleryObj = {
                  "src": imgSrc,
                  "thumb": galleryElement.querySelector('img').src ? galleryElement.querySelector('img').src : imgSrc,
                  "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : "",
                  "iframe": true,
              };
          }
          if (galleryElement.dataset.poster) {
              galleryObj = {
                  "src": imgSrc,
                  "poster": galleryElement.dataset.poster,
                  "subHtml": galleryElement.dataset.subHtml ? galleryElement.dataset.subHtml : "",
              };
          }
          galleryItemsArray.push(galleryObj);
      });
      galleryItems.forEach(galleryItem => {
          if (galleryItem.dataset.iframe) {
              let iframeSelector = '.lg-video iframe.lg-object';
              galleryItem.addEventListener('onAfterOpen', event => {
                  videoUtils.sandboxVideos(iframeSelector);
              });
              galleryItem.addEventListener('onBeforeSlide', event => {
                  videoUtils.sandboxVideos(iframeSelector);
              });
          }
          
          galleryItem.addEventListener('click', event => {
              const currentItemIndex = galleryItem.dataset.index;
              lightGallery(galleryItem, {
                  dynamic: true,
                  index: parseInt(currentItemIndex),
                  mode: 'lg-slide',
                  zoom: (galleryItem.dataset.iframe ? false : true),
                  fullScreen: (galleryItem.dataset.iframe ? false : true),
                  getCaptionFromTitleOrAlt: true,
                  download: false,
                  share: false,
                  subHtmlSelectorRelative: true,
                  dynamicEl: galleryItemsArray,
              });
          });
  
          galleryItem.classList.add('lg-initialised');
      });
  }
  
// This function is only used in the gallery component
function isMobileDevice() {
    let check = false;
    (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || window.opera);
    let mobileAndTablet = Math.min(window.screen.width, window.screen.height) < 900;
    return check || mobileAndTablet;
}
